import { Property } from '@/components/form/fields/select/SelectInput';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/popover/Popover';
import SiFilter from '@/icons/SiFilter';
import { FunctionComponent, useState } from 'react';
import { getCreditStatusOptions } from '../creditCheckHelper';

interface MappedStatus extends Property {
  checked: boolean;
}

interface CreditCheckFilterProps {
  onChangeCallback: (query: string) => void;
}

const CreditCheckStatusFilter: FunctionComponent<CreditCheckFilterProps> = ({ onChangeCallback }) => {
  const statuses = getCreditStatusOptions();

  const mapInitialStatuses = () => {
    return statuses.map(item => ({
      ...item,
      checked: false
    })) as MappedStatus[];
  };

  const [mappedStatuses, setMappedStatuses] = useState(mapInitialStatuses());

  const onChecked = (status: MappedStatus) => {
    status.checked = !status.checked;
    setMappedStatuses([...mappedStatuses]);

    const checkedItems = mappedStatuses.filter(status => status.checked).map(status => status.id);
    const query = checkedItems.join(' | ');

    onChangeCallback(query);
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="relative flex items-center justify-center gap-1 overflow-clip rounded-lg border py-1.5 px-3 text-sm disabled:opacity-40 disabled:pointer-events-none bg-white border-primary-std text-primary-std hover:bg-primary-std font-medium">
          <SiFilter className="text-xl" />
          Filter
        </button>
      </PopoverTrigger>
      <PopoverContent>
        <div className="flex flex-col gap-1 max-h-[20rem] overflow-auto [&>*]:border-b">
          {mappedStatuses.map(status => (
            <div key={status.id} className="flex space-x-2 justify-between items-center py-1 pl-1 pr-3">
              <p>{status.name}</p>
              <input onClick={() => onChecked(status)} checked={status.checked} className="w-4 h-4" type="checkbox" />
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default CreditCheckStatusFilter;
